(function ($) {


const Init = (() => {

  // settings
  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      pages        = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      form         = {},
      formMethod   = {},
      timer        = {},
      wp           = {},
      iscroll      = {},
      loading      = {},
      totop        = {},
      scrollbar    = {},
      canvas       = {},
      tab          = {},
      favorite     = {},
      accordion    = {},
      megamenu     = {};
  
  website = {
    page          : document.body.dataset.page,
    load          : document.body.dataset.load,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : $('.l-header'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  website.shiftPoint = website.breakpoint.tb;
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  
  pages = {
    common : [],
    top    : [],
  }
  

  //modules
  // サニタイズ関数
  function sanitizing(str){
    var before = new Array('&','"',"'","<",">","\n","\t","\\n");
    var after = new Array('&amp;','&quot;','&rsquo;',"&lt;","&gt;","<br />"," ","<br />");
    for( var i=0; i < before.length; i++ )
      str = str.replace(new RegExp(before[i],'g'), after[i]);
    return str;
  };
  
  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  
  const Modules = {
  
    init() {
      mod = {
        targetSmooth    : 'js-scroll',
        targetTotop     : 'js-totop',
        smoothSpeed     : 600,
  
        targetModal     : 'js-modal',
        targetModalOpen : 'js-modalOpen',
        targetModalClose: 'js-modalClose',
  
        targetAlign     : 'js-align',
        targetAlignList : [],
        alignAddClass   : 'c-alignheight',
  
        targetOfi       : '.js-ofi .ofi',
  
        targetPagenavi  : 'js-pagenavi',
  
        targetDateField : 'js-datepicker',
  
        targetPullTrg   : 'js-pulldown',
        targetPullConts : 'js-pulldown_cont',
  
        confirmTrg      : 'js-confirmMsg',
  
        alertTrg        : 'js-alertMsg',
  
        removeTrg       : 'js-remove',
  
        hideTrg         : 'js-hide',
  
        cloneTrg        : 'js-clone',
  
      };
  
      let alignList = document.querySelectorAll('.' + mod.targetAlign);
      mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      // this.tabBtn();
      this.modalBtn();
      this.pulldown();
      this.confirmMessage();
      this.alertMessage();
      this.cloneElement();
      this.removeElement();
      this.hideElement();
  
      objectFitImages(mod.targetOfi);
      Stickyfill.add('.js-sticky');
    },
  
    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#") ? 'html' : href ),
            position;
        if( website.headTag.css('position') == 'fixed' ){
          shift    = ( (href != "#") ) ? website.headTag.outerHeight() : 0;
        }else{
          shift    = 0;
        }
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
        return false;
      });
    },
  
    modalBtn() {
      $('.'+mod.targetModalOpen).on('click',function(){
        $('body').addClass('is-modalOpen');
        let target = $(this).attr('href');
        $(target).fadeIn();
        return false;
      });
      $('.'+mod.targetModalClose).on('click',function(){
        $('body').removeClass('is-modalOpen');
        $(this).closest('.'+mod.targetModal).fadeOut();
        return false;
      });
    },
  
    alignHeight() {
      let alignHeight  = 0;
  
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(mod.alignAddClass);
        alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
        target.classList.remove(mod.alignAddClass);
      });
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = alignHeight + 'px';
      });
    },
  
    pulldown (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+ mod.targetPullTrg).hover(
          function(){
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetPullConts).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetPullConts).removeClass('is-act').stop().slideUp();
          }
        )
      } else{
        $('.'+mod.targetPullTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetPullTrg).find('.'+mod.targetPullConts).toggleClass('is-act').stop().slideToggle();
          if(!$(this).parent('.'+mod.targetPullTrg).hasClass('is-act')){
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
            return false;
          }else{
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
          }
        });
      }
    },
  
    confirmMessage() {
      if( $('.' + mod.confirmTrg ).length ){
        $('.' + mod.confirmTrg ).on('click', function(){
          let message = $(this).attr('data-confirm-message'),
              redirect = $(this).attr('data-url');
          let result = window.confirm(message);
          if( result ){
            window.location.href = redirect;
          }
        });
      }
    },
  
    alertMessage() {
      if( $('.' + mod.alertTrg ).length ){
        $('.' + mod.alertTrg ).on('click', function(){
          let message = $(this).attr('data-alert-message');
          alert(message);
        });
      }
    },
    removeElement() {
      $('.'+mod.removeTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).remove();
        return false;
      });
    },
    cloneElement() {
      $('.'+mod.cloneTrg).each(function(){
        let target = $(this).data('target');
        $(target).clone(true).appendTo($(this));
      });
    },
    hideElement() {
      $('.'+mod.hideTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).hide();
        return false;
      });
    },
  }
  
  const DrawerMenu = {
  
    init() {
      drawer = {
        panel     : 'js-so_panel',
        menu      : 'js-so_menu',
        duration  : 10,
        // openclass : 'slideout-open',
        toggleList: '#js-so_toggle',
        closeList : '#js-so_panel, #js-so_menu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });
  
      let nodeList = document.querySelectorAll(drawer.toggleList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });
  
      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },
  
  }
  
    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  
  const Slick = {
  
    init() {
      this.topKey();
      this.worksSlide();
      this.calenderSlide();
    },
  
    topKey() {
      if($('.js-kv').length){
        let autospeed = 5000;
        $('.js-kv').slick({
          fade: true,
          autoplay: true,
          autoplaySpeed: autospeed,
          speed: 1000,
          cssEase: 'linear',
          arrows: false,
          dots: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              // breakpoint: website.breakpoint.ss,
              // settings: {
              //   dots: false,
              // }
  
            },],
        });
      }
    },
    worksSlide() {
      if($('.js-workSlide').length){
        $('.js-workSlide').each(function(){
          let $main_slide  = $(this).find('.js-workSlideMain'),
              $thumb_slide = $(this).find('.js-workSlideThumbs');
            $main_slide.slick({
              fade: true,
              accessibility: false,
              swipe: false,
              touchMove: false,
              draggable: false,
              autoplay: false,
              autoplay: false,
              speed: 1000,
              cssEase: 'linear',
              arrows: false,
              dots: false,
              slidesToShow:1,
              slidesToScroll:1,
              pauseOnFocus: true,
              pauseOnHover: true,
              centerMode: false,
              asNavFor: $thumb_slide,
            });
            $thumb_slide.slick({
              fade: false,
              autoplay: false,
              speed: 200,
              cssEase: 'linear',
              arrows: false,
              dots: true,
              slidesToShow:5,
              slidesToScroll:1,
              pauseOnFocus: true,
              pauseOnHover: true,
              centerMode: false,
              asNavFor: $main_slide,
              focusOnSelect: true,
              responsive: [
                {
                  breakpoint: website.breakpoint.tb,
                  settings: {
                    slidesToShow:4,
                  },
                },
                {
                  breakpoint: website.breakpoint.ss,
                  settings: {
                    slidesToShow:3,
                  },
                },
              ],
            });
        });
      }
    },
    calenderSlide() {
      if($('.js-calenderSlide').length){
        $('.js-calenderSlide').each(function(){
          let $main_slide  = $(this).find('.js-calenderMain'),
              $sub_slide   = $(this).find('.js-calenderSub'),
              init_month    = $(this).attr('data-month'),
              init_slide_num;
              init_slide_num = $sub_slide.find('[data-month="'+init_month+'"]').index();
  
          $main_slide.slick({
            fade: true,
            swipe: false,
            autoplay: false,
            speed: 200,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $sub_slide,
            initialSlide : init_slide_num,
            infinite: false
          });
          $sub_slide.slick({
            fade: true,
            autoplay: false,
            speed: 200,
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $main_slide,
            initialSlide : init_slide_num,
            infinite: false,
          })
        });
      }
    }
  }
  
  const Megamenu = {
  
    init() {
      megamenu = {
        wrapElm  : '.js-megaWrap',
        trgElm   : '.js-megaTrg',
        contElm  : '.js-megaCont',
      }
      this.adjust();
      this.action();
    },
    action(){
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        $(megamenu.trgElm).children('a').on('click',function(){
          if($(this).hasClass('is-act')){
            $(this).removeClass('is-act');
            $(this).siblings(megamenu.contElm).removeClass('is-act').stop().slideUp();
          }else{
            Megamenu.close();
            $(this).addClass('is-act');
            $(this).siblings(megamenu.contElm).addClass('is-act').stop().slideDown();
          }
        });
      }
    },
    close() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        $(megamenu.contElm).removeClass('is-act').stop().slideUp(100).siblings('a').removeClass('is-act');
      }
    },
    adjust() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        let positionY = website.headTag.outerHeight();
        $(megamenu.contElm).css('top', positionY+'px');
      }
    }
  }
  
  const Totop ={
    init(){
      totop = {
        targetClass : '.js-totop',
        speed       : 600,
      }
      if($(totop.targetClass).length){
        this.check();
        this.action();
      }
    },
    check(){
      if( website.scrollY > 100 ){
        $( totop.targetClass ).addClass('is-act').fadeIn(400);
      }else{
        $( totop.targetClass ).removeClass('is-act').fadeOut(400);
      }
    },
    action(){
      $( totop.targetClass ).on('click',function(){
        $('body,html').animate({scrollTop: 0}, totop.speed, 'swing');
        return false;
      });
    }
  }
  
  const Timer = {
    init() {
      timer = {
        targetClass : '.js-timer',
      };
      this.check();
    },
    check() {
      if($(timer.targetClass).length){
        $(timer.targetClass).hide();
        $(timer.targetClass).each(function(){
          let startTime   = new Date($(this).data('start')),
              endTime     = new Date($(this).data('end')),
              currentTime = new Date();
          if(startTime <= currentTime && currentTime <= endTime){
            $(this).show();
            return false;
          }
        });
      }
    }
  }
  
  const Accordion = {
  
    init() {
      accordion = {
        toggleElm : '.js-accordion',
        openElm   : '.js-accordionOpen',
        closeElm   : '.js-accordionClose',
      };
      this.toggle();
      this.open();
      this.close();
    },
  
    toggle() {
      if($(accordion.toggleElm).length){
        $(accordion.toggleElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              return false;
            } else {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              return false;
            }
          }else{
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
            }
          }
        });
      }
    },
    open() {
      if($(accordion.openElm).length){
        $(accordion.openElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(this).addClass(website.act).next().stop().slideDown();
              $(this).hide();
            }
          }
        });
      }
    },
    close() {
      if($(accordion.closeElm).length){
        $(accordion.closeElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              $(this).hide();
            }
          }
        });
      }
    }
  
  }
  
  const Wordpress = {
  
    init() {
      wp = {
        editorTarget: '.js-editor',
        tableClass  : 'c-tbl_responsive',
        tableInnerClass  : 'c-tbl_responsive__inner',
        iframeclass : 'c-iframe',
      }
  
      this.wpEditor();
    },
  
    wpEditor() {
      if ( $(wp.editorTarget).length ) {
        $( wp.editorTarget + ' table' ).each(function() {
          $(this).wrap('<div class="' + wp.tableClass + '"><div class="' + wp.tableInnerClass + '"></div></div>');
        });
        $(  wp.editorTarget + ' iframe' ).each(function() {
          $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        });
      }
      // if ( $('.' + wp.editorTarget).length ) {
      //   $( '.' + wp.editorTarget + ' table' ).each(function() {
      //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
      //   });
      //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
      //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
      //   });
      // }
    }
  
  }
  
  const Loading = {
    init(){
      loading = {
        targetClass : '.js-loading',
      }
      Loading.action();
    },
    action(){
      $('html,body').animate({scrollTop: 0}, 0, 'swing');
      $( loading.targetClass ).find('svg path:not([data-animate="false"])').velocity({
        strokeDashoffset: 0,
      },{
        duration: 2000,
        easing: 'linear',
        complete: function(){
          $( loading.targetClass ).find('svg path').velocity({
            fillOpacity: 1,
            strokeAlpha: 0,
          },{
            duration: 500,
            easing: 'linear',
            complete: function(){
              $( loading.targetClass ).delay(400).fadeOut(400,function(){
                Slick.init();
                $('body').attr('data-load','true');
              });
            }
          });
        }
      });
    },
  }
  


  // OFF
  // ./inc/_pagescroll.js
  // ./inc/_parallax.js
  // ./inc/_form.js
  // ./inc/_favorite.js


  // page
  const BasicPage = {
    init() {
      pages.common = {
        fixedMenuTrg: '.js-menu',
        fixedMenuElm: '.js-fixed_menu',
        fixedContactElm: '.js-fixed_contact',
        fixedContactTrg: '.js-fixed_contactTrg',
        scrollContentTrg: '.js-scrollCont',
      };
      this.fixedContact();
      this.scrollContent();
    },
    fixedHeader(){
      let position = $(pages.common.fixedMenuTrg).offset().top + $(pages.common.fixedMenuTrg).outerHeight();
      if(website.scrollY > position){
        $(pages.common.fixedMenuElm).fadeIn();
      }else{
        $(pages.common.fixedMenuElm).hide();
      }
    },
    fixedContact(){
      if(website.winWidth >= website.breakpoint.sp){
          $(pages.common.fixedContactElm).hover(
            function(){
              $(this).addClass('is-show');
            },
            function(){
              $(this).removeClass('is-show');
            }
          );
        // if(website.winWidth >= website.breakpoint.tb){
        //   $(pages.common.fixedContactElm).hover(
        //     function(){
        //       $(this).addClass('is-show');
        //     },
        //     function(){
        //       $(this).removeClass('is-show');
        //     }
        //   );
        // }else{
        //   $(pages.common.fixedContactTrg).on('click',function(){
        //     console.log('test');
        //     $(this).parents(pages.common.fixedContact).toggleClass('is-show');
        //   });
        // }
      }else{
        if(website.scrollY > 100){
          $(pages.common.fixedContactElm).addClass('is-show');
        }else{
          $(pages.common.fixedContactElm).removeClass('is-show');
        }
      }
    },
    scrollContent(){
      if(website.scrollY > 100){
        $(pages.common.scrollContentTrg).addClass('is-act');
      }else{
        $(pages.common.scrollContentTrg).removeClass('is-act');
      }
    },
    update() {
    },
  }
  
  //= ./page/_top.js



  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        // Wordpress.init();
      }
    },

    set() {
      BasicPage.init();
      Modules.init();
      DrawerMenu.init();
      Wordpress.init();
      // Animation.init();
      // PageScroll.init();
      // Parallax.init();
      if(website.load == 'false'){
        Loading.init();
      }else{
        Slick.init();
      }

      if ( website.page == 'top' ) {
        // TopPage.init();
      } else if( website.page  == 'contact' ) {
        // Form.init();
      }

      WinLoad.add( Animation.check );
      WinLoad.add( BasicPage.fixedHeader );
      // WinLoad.add( Modules.megaMenu );
      // WinLoad.add( Iscroll.check );

      WinResize.add( Modules.iosCheck );
      WinResize.add( Modules.deviceCheck );
      WinResize.add( BasicPage.fixedHeader );

      WinScroll.add( Animation.check );
      WinScroll.add( BasicPage.fixedHeader );
      WinScroll.add( BasicPage.scrollContent );
      // WinScroll.add( Totop.check );
      // WinScroll.add( Iscroll.check );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
